import { combineReducers } from '@reduxjs/toolkit';

import appointment from '~/store/reducers/appointment';
import inquiryList from '~/store/reducers/inquiryList';
import patientLabTab from '~/store/reducers/patientLabTab';
import processedAigssEvents from '~/store/reducers/processedAigssEvents';
import safetyAlerts from '~/store/reducers/safetyAlerts';
import api from '~/store/services/api';
import iqApi from '~/store/services/api/iqApi';

import { rolesReducer } from './userPermissions';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [iqApi.reducerPath]: iqApi.reducer,
  appointment,
  inquiryList,
  patientLabTab,
  processedAigssEvents,
  rolesReducer,
  safetyAlerts,
});

export default rootReducer;
